import {Injectable} from '@angular/core';
import {MyDialogDataModel} from '../models/my-dialog-data.model';
import {ContainerUtilsService} from './container-utils.service';
import {ProductModel} from '../models/product.model';
import {MyContainerSharedMetadataModel} from '../models/my-container-shared-metadata.model';
import {MyProductAmountModel} from '../models/my-product-amount.model';
import {MyDeviceRequestContainerModel} from '../models/my-device-request-container.model';
import {ProductCategoryTypeEnum} from '../enums/product-category-type.enum';
import {MyNotDeviceRequestContainerModel} from '../models/my-not-device-request-container.model';
import {ProjectModel} from '../models/project.model';
import {RequestedDeviceItemModel} from '../models/requested-device-item.model';
import {PriceInfoModel} from '../models/price-info.model';
import {RequestedNotDeviceItemModel} from '../models/requested-not-device-item.model';
import {HardwareTonerColorInfoEnum} from '../enums/hardware-toner-color-info.enum';

@Injectable()
export class ContainerListsUtilsService {

    private _dialogModel: MyDialogDataModel;

    constructor(
        private containerUtilsService: ContainerUtilsService,
    ) {
    }

    public initDialogModel(dialogModel: MyDialogDataModel) {
        this._dialogModel = dialogModel;
    }

    get dialogModel(): MyDialogDataModel {
        if (!this._dialogModel) {
            console.error('ContainerUtilsService dialogModel connection is not initialized yet');
        }
        return this._dialogModel;
    }


    /**
     * initialize all available product containers (devices, accessories, warranties, supplies)
     * ( creates product tree and filtered arrays )
     * device requests is not initialized, because at this point we dont know  which will be requested
     * so is should be initialized later if the product is requested by user
     * and because currently (by new spec) the product list contains rPrices, it si possible at this point
     * @param products
     */
    public wrapProductsWithContainers(products: ProductModel[]): void {
        // initContainers

        // test statistic
        // console.log('product statistic (testing purpose only)');
        // console.log('wrapProductsWithDeviceContainers for products, products length:', products.length);
        // console.log(' - products:', products);
        // console.log(' - print smart devices amount:', products.filter(product => product.printSmart).length);
        // console.log(' - print smart devices with defined mpsSuppies amount:', products.filter(product => product.printSmart && product.mpsSupplies && product.mpsSupplies.length).length,
        //     ', devices:',  products.filter(product => product.printSmart && product.mpsSupplies && product.mpsSupplies.length));
        // console.log(' - print smart color devices amount:', products.filter(product => product.printSmart && product.hardwareColorTonerInfo === HardwareTonerColorInfoEnum[HardwareTonerColorInfoEnum.COLOR]).length);
        // console.log(' - print smart mono devices amount:', products.filter(product => product.printSmart && product.hardwareColorTonerInfo === HardwareTonerColorInfoEnum[HardwareTonerColorInfoEnum.MONO]).length);
        // console.log(' - print smart devices:', products.filter(product => product.printSmart));
        // console.log(' - products with parents:', products.filter(product => product.applicableToProducts).length);
        // console.log(' - devices with parents:', products.filter(product => ProductModel.isDevice(product) && product.applicableToProducts).length);
        // console.log(' - supplies with parent:', products.filter(product => product.category.toString() === 'SUPPLY' && product.applicableToProducts).length);
        // console.log(' - accessories with parent:', products.filter(product => product.category.toString() === 'ACCESSORY' && product.applicableToProducts).length);
        // console.log(' - warranties with parent:', products.filter(product => product.category.toString() === 'WARRANTY' && product.applicableToProducts).length);
        // let NotDevicesNoParents = products.filter(product =>
        //     (product.category.toString() === 'WARRANTY'
        //         || product.category.toString() === 'SUPPLY'
        //         || product.category.toString() === 'ACCESSORY')
        //     && !product.applicableToProducts);
        // console.log(' - noDevices without parent(usually ACCESSORY): ' + NotDevicesNoParents.length, NotDevicesNoParents);
        // console.log(' - noDevices without parent(not ACCESSORY): ' + NotDevicesNoParents.filter(accessory => accessory.category.toString() !== 'ACCESSORY').length);


        // process all DEVICES (not supplies, accessories or warranties)

        const deviceMap: {  // which product the given supply can worked with
            // ID of Device
            [key: number]: {
                // SKU of Supply
                [key: string]: boolean;
            };
        } = {};
        const supplyMap: {
            // SKU of Supply
            [key: string]: {
                // ID of Device
                [key: number]: boolean;
            };
        } = {};

        // console.log('products MFCL69', products.filter(pr => pr.sku.indexOf('MFCL69') > -1));


        const deviceContainers = products.filter(product => ProductModel.isDevice(product)).map(deviceProduct => {
            const productContainerMetadata = new MyContainerSharedMetadataModel();


            deviceMap[deviceProduct.id] = {};
            for (const supply of deviceProduct.mpsSupplies || []) {
                deviceMap[deviceProduct.id][supply] = true;
                if (!supplyMap[supply]) {
                    supplyMap[supply] = {};
                }
                supplyMap[supply][deviceProduct.id] = true;
            }

            const productContainer = {
                id: deviceProduct.id.toString(),
                itemToOrder: deviceProduct as ProductModel,
                isDevice: true,
                containerSharedMetadata: productContainerMetadata,  // which array the container belongs to
                // deviceRequest: this.getNewDeviceRequest(),
                deviceRequest: null,
                deviceAmount: new MyProductAmountModel(),
                accessories: [],
                supplies: [],
                mpsSupplies: [],
                warranties: [],
                upgrades: [],
            } as MyDeviceRequestContainerModel;

            // at this point deviceRequest remains empty, because most of properties will comes form user input except sku
            // in fact im not sure if this sku is really used in the logic,
            // deviceRequest model comes form rest and contains this value, so is initialized, but it is duplicated value with itemToOrder.sku
            // productContainer.deviceRequest.sku = productContainer.itemToOrder.sku;

            return productContainer as MyDeviceRequestContainerModel;

        });

        // add all devicesContainers to the availableDevicesContainers (without subArrays content like accessories, sup., war.).
        // deviceContainers serve only as shortcut for this.dialogModel.availableDevicesContainers
        this.dialogModel.availableDevicesContainers = deviceContainers;


        // console.log('deviceContainers', deviceContainers);

        // process all others (supplies, warranties)... filter NotDeviceProducts to new array
        const NotDeviceProducts = products.filter(product => !ProductModel.isDevice(product));
        let counter = 0;

        // init arrays and create arrays shortcuts for easier manipulation
        this.dialogModel.availableWarrantyContainers = [];
        const availableWarrantyContainers = this.dialogModel.availableWarrantyContainers;

        this.dialogModel.availableAccessoryContainers = [];
        const availableAccessoryContainers = this.dialogModel.availableAccessoryContainers;

        this.dialogModel.availableUpgradesContainers = [];
        const availableUpgradesContainers_Sc = this.dialogModel.availableUpgradesContainers;

        this.dialogModel.noParentUpgradesContainersIndex = [];
        const noParentUpgradesContainersIndex_Sc = this.dialogModel.noParentUpgradesContainersIndex;

        this.dialogModel.noParentWarrantyContainersIndex = [];
        const noParentWarrantyContainersIndex = this.dialogModel.noParentWarrantyContainersIndex;

        this.dialogModel.noParentAccessoryContainersIndex = [];
        const noParentAccessoryContainersIndex = this.dialogModel.noParentAccessoryContainersIndex;

        this.dialogModel.availableSuppliesContainers = [];
        const availableSuppliesContainers = this.dialogModel.availableSuppliesContainers;

        // this.dialogModel.availableGeneralNoCategorisedSupplyContainers = [];
        // const availableGeneralNoCategorisedSupplyContainers = this.dialogModel.availableGeneralNoCategorisedSupplyContainers;


        this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers = [];
        this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers = [];

        // console.log('NotDeviceProducts', NotDeviceProducts);


        for (const notDeviceProduct of NotDeviceProducts) {
            if (!supplyMap[notDeviceProduct.sku]) {
                supplyMap[notDeviceProduct.sku] = {};
            }
            for (const applicableToDevice of !!notDeviceProduct.applicableToProducts ? notDeviceProduct.applicableToProducts : []) {
                if (deviceMap[applicableToDevice]) {
                    // console.log('applicableToDevice', applicableToDevice);

                    deviceMap[applicableToDevice][notDeviceProduct.sku] = true;
                    supplyMap[notDeviceProduct.sku][applicableToDevice] = true;
                } else {
                    console.warn('product cannot be applied to device, because the device with given id was not found:', applicableToDevice);
                    console.log(' - not connected product with device ' + applicableToDevice, notDeviceProduct);
                }

            }
        }

        NotDeviceProducts.forEach(notDeviceProduct => {


            // add all notDevice product to its dedicated typeContainerArray

            const currentNotDeviceCategoryType = ProductCategoryTypeEnum[notDeviceProduct.category];


            // create container for current notDevice product
            const wasContainer = { // create container for warranty/accessory/supply/upgrades/service
                id: notDeviceProduct.id.toString() + '-' + counter++,
                itemToOrder: notDeviceProduct,
                isDevice: false,
                containerSharedMetadata: {addToProductOrderList: false} as MyContainerSharedMetadataModel, // used to share select state throw 3.step dialog tabs and so on
                // notDeviceRequest: this.getNewNotDeviceItemRequest(),  // contains parentSkuMapping, price note , price levels
                notDeviceRequest: null,  // contains parentSkuMapping, price note , price levels
                waAcLsAmount: null,
                parentDeviceDedicatedGeneralSupplyMetadata: null,
                parentPrintSmartDedicatedSupplyAmount: null,
                noParentGeneralSupplyAmount: null,
                parent: null
            } as MyNotDeviceRequestContainerModel;


            // at this point notDeviceRequest remains empty, because most of properties/data will comes form user inputs except sku
            // wasContainer.notDeviceRequest.sku = wasContainer.itemToOrder.sku;


            // wasContainer.notDeviceRequest.parentSkuMapping = undefined;  // useless for warranty and accessory

            switch (currentNotDeviceCategoryType) {

                case ProductCategoryTypeEnum.WARRANTY:
                    // 1D arr. used on Warranties tab (3. page) ... contains all warranties ( with and without device parent)
                    // currently the notDeviceRequest in container is initialized, from this array,
                    // the container will be copied to requestedWarranties so, the object will be initialized also for requestedWarranties
                    availableWarrantyContainers.push(wasContainer);
                    break;
                case ProductCategoryTypeEnum.ACCESSORY:
                    // 1D arr. used on Accessories tab (3. page) ... contains all Accessories ( with and without device parent)
                    availableAccessoryContainers.push(wasContainer);
                    break;

                case ProductCategoryTypeEnum.UPGRADE:
                    availableUpgradesContainers_Sc.push(wasContainer);
                    break;

                case ProductCategoryTypeEnum.SUPPLY:

                    // remove fields which is not used for supplies
                    delete wasContainer.containerSharedMetadata.addToProductOrderList;
                    availableSuppliesContainers.push(wasContainer);
                    break;
                default:
                    console.warn('unknown not device category found', wasContainer);
            }


            // connect notDevices with its devices (if the connection is defined in applicableToProducts)
            // or add to NotDeviceProductContainers
            const applicableToProducts = Object.keys(supplyMap[notDeviceProduct.sku]).map(id => +id);
            if (applicableToProducts?.length > 0) {
                // process all NotDevices(war,sup,acc) products with applicableToProduct array,
                // which would be "added to/connected" with several devices
                // applicableToProduct is similar like project parentSkuMapping but use ids for notProduct to Device connection registering

                let skippedIds = '';

                applicableToProducts.forEach(deviceId => {

                    // applicableToProducts array contains all device ids, which should be notDeviceItem added to
                    // find deviceContainer (device to connect with) containing device with given id
                    const deviceContainerToAddTo = deviceContainers.find(container => container.itemToOrder.id === deviceId);

                    if (!deviceContainerToAddTo) {
                        skippedIds += deviceId + ',';

                        // let pr = this.dialogModel.products.find(product => product.id === deviceId);
                        // let gr = this.dialogModel.products.filter(product => product.id.toString().indexOf(deviceId.toString().slice(0, 2)) > -1);
                        // console.log(deviceId + ' found', pr);
                        // console.log('this.dialogModel.products', gr);
                    } else {
                        // console.log('id found', deviceContainerToAddTo);
                        // create new NotDeviceContainer subItem ... we need it to generate different id for each row  in categorised views,
                        // even it si the same product, to simplify html logic
                        const deviceChildWasContainer = Object.assign(new MyNotDeviceRequestContainerModel(), wasContainer);
                        deviceChildWasContainer.parent = deviceContainerToAddTo;
                        deviceChildWasContainer.id = notDeviceProduct.id.toString() + '-' + counter++;

                        // the all amounts object are still null - not initialized,
                        // they are initialized later only if and just before they are needed
                        switch (currentNotDeviceCategoryType) {
                            case ProductCategoryTypeEnum.WARRANTY:
                                // warranty and accessory are not requested via 2D device array,
                                // so notDeviceRequest is useless in 2D array at this point, but must be available via requestedWarranties
                                // deviceChildWasContainer.notDeviceRequest = null;
                                deviceContainerToAddTo.warranties.push(deviceChildWasContainer);
                                break;
                            case ProductCategoryTypeEnum.ACCESSORY:
                                // warranty and accessory are not requested via 2D device array,
                                // so notDeviceRequest is useless at this point , but must be available via requestedAccessories
                                // deviceChildWasContainer.notDeviceRequest = null;
                                deviceContainerToAddTo.accessories.push(deviceChildWasContainer);
                                break;
                            case ProductCategoryTypeEnum.UPGRADE:
                                // warranty and accessory are not requested via 2D device array,
                                // so notDeviceRequest is useless at this point , but must be available via requestedAccessories
                                // deviceChildWasContainer.notDeviceRequest = null;
                                // PPU note: after new 4.step was added the deviceContainerToAddTo.accessories seems to be useless
                                deviceContainerToAddTo.upgrades.push(deviceChildWasContainer);
                                break;
                            case ProductCategoryTypeEnum.SERVICE:
                                console.error('unexpected product type', deviceChildWasContainer);
                                break;
                            case ProductCategoryTypeEnum.SUPPLY:

                                // the amount is now known, skip the calculation ( we dont know start and end dates and so on at this point)
                                // if (deviceContainerToAddTo.itemToOrder.printSmart) {
                                //     // deviceChildWasContainer.parentPrintSmartDedicatedSupplyAmount = new MyProductAmountModel
                                //     // this.containerUtilsService.calculateMPSSuppliesAmount(deviceChildWasContainer);
                                //     // deviceChildWasContainer.parentPrintSmartDedicatedSupplyAmount =  new MyProductAmountModel();
                                // }

                                if (deviceContainerToAddTo.itemToOrder.printSmart) {
                                    // for printSmarts devices add only toners which is listed in mpsSupplies
                                    if (deviceContainerToAddTo.itemToOrder.mpsSupplies.some(sku => sku === deviceChildWasContainer.itemToOrder.sku)) {

                                        if (!!deviceChildWasContainer.itemToOrder.tonerInfo) {
                                            deviceContainerToAddTo.mpsSupplies.push(deviceChildWasContainer);
                                        } else {
                                            console.warn('missing tonerInfo data in MPS supply, supply cannot be processed as MPS supply - supplyContainer:', deviceChildWasContainer);
                                        }

                                    }
                                }
                                deviceContainerToAddTo.supplies.push(deviceChildWasContainer);
                                break;
                            default:
                                console.warn('connecting with parent device - unrecognized container type:' + currentNotDeviceCategoryType, wasContainer);
                        }
                    }


                });
                if (skippedIds !== '') {
                    console.warn('applicableToProducts processing - some products do not exist and was not processed, deviceIds:', skippedIds);
                }
            } else {
                // process notDevices (warranties, accessories, supplies) which not contains applicableToProducts product array,
                // so they are not connected with any device
                // and amounts will be stored in this arrays and edited only via these arrays on 3.page
                // so no copy of wasContainer of ProductAmount is needed

                switch (currentNotDeviceCategoryType) {
                    case ProductCategoryTypeEnum.WARRANTY:
                        // wasContainer.notDeviceRequest.priceNote = 'debug info ... initialized via wrapProductWithDeviceContainer 820noPar';
                        noParentWarrantyContainersIndex.push(wasContainer);
                        break;
                    case ProductCategoryTypeEnum.ACCESSORY:
                        // wasContainer.notDeviceRequest.priceNote = 'debug info ... initialized via wrapProductWithDeviceContainer 820noPar';
                        noParentAccessoryContainersIndex.push(wasContainer);
                        break;
                    case ProductCategoryTypeEnum.SUPPLY:
                        // wasContainer.notDeviceRequest.priceNote = 'debug info ... initialized via wrapProductWithDeviceContainer 820noPar';
                        // availableGeneralNoCategorisedSupplyContainers.push(wasContainer);
                        break;

                    case ProductCategoryTypeEnum.UPGRADE:
                        noParentUpgradesContainersIndex_Sc.push(wasContainer);
                        break;
                    default:
                        console.warn('unrecognized container type:' + ProductCategoryTypeEnum[currentNotDeviceCategoryType], wasContainer);
                }
            }

        });

        // console.log('available containers without user data have ben created in dialogModel', this.dialogModel);
        // -------------------------------
        // PPU_log console.log('sorting containers...');
        this.sortContainersArray(this.dialogModel.availableDevicesContainers);
        this.sortContainersArray(this.dialogModel.availableWarrantyContainers);
        this.sortContainersArray(this.dialogModel.availableAccessoryContainers);
        this.sortContainersArray(this.dialogModel.noParentWarrantyContainersIndex);
        this.sortContainersArray(this.dialogModel.noParentAccessoryContainersIndex);

        this.sortContainersArray(this.dialogModel.availableUpgradesContainers);
        this.sortContainersArray(this.dialogModel.noParentUpgradesContainersIndex);
        // PPU_log console.log('containers sorted...');


        this.dialogModel.availableDevicesContainersNoCustomProducts = this.dialogModel.availableDevicesContainers.filter(container => !container.itemToOrder.brotherCustomProduct);
        this.dialogModel.availableWarrantyContainersNoCustomProducts = this.dialogModel.availableWarrantyContainers.filter(container => !container.itemToOrder.brotherCustomProduct);
        this.dialogModel.availableAccessoryContainersNoCustomProducts = this.dialogModel.availableAccessoryContainers.filter(container => !container.itemToOrder.brotherCustomProduct);
        this.dialogModel.noParentWarrantyContainersIndexNoCustomProducts = this.dialogModel.noParentWarrantyContainersIndex.filter(container => !container.itemToOrder.brotherCustomProduct);
        this.dialogModel.noParentAccessoryContainersIndexNoCustomProducts = this.dialogModel.noParentAccessoryContainersIndex.filter(container => !container.itemToOrder.brotherCustomProduct);
    }

    private sortContainersArray(containers: MyDeviceRequestContainerModel[] | MyNotDeviceRequestContainerModel[]) {
        const containersToSort = containers as MyDeviceRequestContainerModel[];  // both types contains itemToOrder.sku

        if (containersToSort?.length > 0) {
            containersToSort.sort((a: any, b: any) => {
                return (a.itemToOrder.sku < b.itemToOrder.sku) ? -1 :
                    (a.itemToOrder.sku > b.itemToOrder.sku) ? 1 : 0;
            });

            const isDeviceContainerType = containersToSort[0].isDevice;
            if (isDeviceContainerType) {
                for (const container of containersToSort) {
                    this.sortContainersArray(container.accessories);
                    this.sortContainersArray(container.supplies);
                    this.sortContainersArray(container.mpsSupplies);
                    this.sortContainersArray(container.warranties);
                }
            }
        }
    }


    /**
     * converts supplies containers which has parents device to requestedSupplies array to comply rest data shape requirements
     * @param deviceContainers  - printSmartDeviceContainer or generalDeviceContainer
     */

    public addDevicesSuppliesToRequestedSupplies(deviceContainers: MyDeviceRequestContainerModel[]): void {
        // PPU_log console.log('addDevicesSuppliesToRequestedSupplies starts - deviceSupplies will be converted for rest, deviceContainers:', deviceContainers);
        this.dialogModel.project.requestedSupplyInfo.requestedSupplies = [];
        if (ProjectModel.isSupply_PagePriceAcquisitionType(this.dialogModel.project)) {
            deviceContainers.forEach(deviceContainer => {
                this.containerUtilsService.addPrintSmartContainerPagePricesToRequestedSupplies(deviceContainer);
            });
        } else {
            if (ProjectModel.isPrintSmartSupplyAcquisitionType(this.dialogModel.project)) {
                deviceContainers.forEach(deviceWithSuppliesContainer => {
                    deviceWithSuppliesContainer.mpsSupplies.forEach(mpsSupplyContainer => {
                        this.containerUtilsService.addSupplyContainerToRequestedSupplies(mpsSupplyContainer);
                    });
                });
            } else {
                deviceContainers.forEach(deviceWithSuppliesContainer => {
                    deviceWithSuppliesContainer.supplies.forEach(supplyContainer => {
                        this.containerUtilsService.addSupplyContainerToRequestedSupplies(supplyContainer);
                    });
                });

            }
        }

    }

    public addNoParentDeviceSupplyContainersToRequestedSupplies(supplyContainers: MyNotDeviceRequestContainerModel[]): void {
        supplyContainers.forEach(supplyContainer => {
            this.containerUtilsService.addSupplyContainerToRequestedSupplies(supplyContainer, false);
        });
    }

    // sets ONLY device containerSharedMetadata variables to false
    // reset Device Containers List Metadata and amounts
    public clearDeviceContainersListUserData(deviceContainersList: MyDeviceRequestContainerModel[]): void {

        // console.log('clearDeviceContainersListUserData - user data will be removed form containerArray:', deviceContainersList);

        deviceContainersList.forEach(deviceContainer => {
            // attention: containerSharedMetadata cannot be replaced with new object, otherwise the containers array connection will be lost
            deviceContainer.containerSharedMetadata = Object.assign(deviceContainer.containerSharedMetadata, new MyContainerSharedMetadataModel());
            deviceContainer.deviceAmount.amount = null;

            // deviceContainer.deviceRequest.metaData = new MetaDataModel();
            deviceContainer.deviceRequest = null;  // deviceRequest is newly created just before is needed ( if the item is requested/ work with)

            deviceContainer.supplies.forEach(supply => {
                MyNotDeviceRequestContainerModel.resetUserInputAmounts(supply);
            });

            deviceContainer.devicePricePerPage = null;
        });

        // PPU_log console.log('clearDeviceContainersListUserData finished - user data was removed form containerArray:', deviceContainersList);
    }


    /**
     sets NotDevice containerSharedMetadata variables to false, it removes them  later form all requested arrays
     reset Containers Metadata and amounts
     */
    public clearNotDeviceContainersUserData(containersList: MyNotDeviceRequestContainerModel[]): void {
        containersList.map(containerItem => {
            MyNotDeviceRequestContainerModel.resetUserInputAmounts(containerItem);
            containerItem.containerSharedMetadata = Object.assign(containerItem.containerSharedMetadata, new MyContainerSharedMetadataModel());
            containerItem.notDeviceRequest = null;
            return containerItem as MyNotDeviceRequestContainerModel;
        });
    }


    /**
     * returns only containers, which have addToProductOrderList = true... are selected/ordered by the user
     * addToProductOrderList is dedicated only for 3. and 4. dialog page table, it means it works only with devices, accessorises and warranties (no supplies)
     * amountFieldNameToInit is name of field which will be checked and then initialized before container will be copied
     *
     * note: cannot be used for supply containers
     */
    public filterAndCopyRequestedContainersOnly<T>(availableContainers: T[]): T[] {

        // console.log('copyRequestedContainers for availableContainers', availableContainers);
        const requestedContainers = [] as T[];

        availableContainers.forEach(container => {

            const untypedContainer: any = container;
            const isDevice = untypedContainer.isDevice;

            if (untypedContainer.containerSharedMetadata.addToProductOrderList) {


                if (isDevice) {
                    untypedContainer.deviceAmount = untypedContainer.deviceAmount ? untypedContainer.deviceAmount : new MyProductAmountModel();
                    if (!untypedContainer.deviceRequest) {
                        untypedContainer.deviceRequest = RequestedDeviceItemModel.getNewInstance(PriceInfoModel.getNewInstance(ProductModel.getItemDedicatedRPrices(untypedContainer.itemToOrder as ProductModel)));
                        // PPU_log console.log('new deviceRequest initialized', untypedContainer);
                    }
                } else {
                    untypedContainer.waAcLsAmount = untypedContainer.waAcLsAmount ? untypedContainer.waAcLsAmount : new MyProductAmountModel();
                    if (!untypedContainer.notDeviceRequest) {
                        untypedContainer.notDeviceRequest = RequestedNotDeviceItemModel.getNewInstance(PriceInfoModel.getNewInstance((untypedContainer.itemToOrder as ProductModel).rPrices));
                        // PPU_log console.log('new notDeviceRequest initialized', untypedContainer);
                    }
                }

                const containerFlatCopy = Object.assign({}, container) as T;
                requestedContainers.push(containerFlatCopy);
            }
        });
        return requestedContainers;
    }


    public getContainerBySku(containers: (MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel)[], sku: string):
        MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel {
        if (!containers) {
            return null;
        }
        let containerToReturn = null;
        containers.some(someContainer => {
            if (someContainer.itemToOrder.sku === sku) {
                containerToReturn = someContainer;
                return true;
            }
            return false;
        });
        return containerToReturn;
    }

}
